import { OptionProps, StyleOption } from 'src/types';

export const ageOptions: OptionProps[] = [
  { label: 'under 1 years', value: '0' },
  { label: '1 years', value: '1' },
  { label: '2 years', value: '2' },
  { label: '3 years', value: '3' },
  { label: '4 years', value: '4' },
  { label: '5 years', value: '5' },
  { label: '6 years', value: '6' },
  { label: '7 years', value: '7' },
  { label: '8 years', value: '8' },
  { label: '9 years', value: '9' },
  { label: '10 years', value: '10' },
  { label: '11 years', value: '11' },
  { label: '12 years', value: '12' },
];
export const traningTopicsOptions: OptionProps[] = [
  { label: 'Sleep and Bedtime Issues', value: 'Sleep and Bedtime Issues' },
  { label: 'Anxiety', value: 'Anxiety' },
  {
    label: 'Environmental Responsibility',
    value: 'Environmental Responsibility',
  },
  { label: 'Respect and Kindness', value: 'Respect and Kindness' },
  {
    label: 'Potty Training and Toilet Issues',
    value: 'Potty Training and Toilet Issues',
  },
  { label: 'Anger', value: 'Anger' },
  { label: 'Financial', value: 'Financial' },
  { label: 'Teamwork', value: 'Teamwork' },
  { label: 'Defiance', value: 'Defiance' },
  { label: 'Separation Anxiety', value: 'Separation Anxiety' },
  {
    label: 'Nutrition and Eating Habits',
    value: 'Nutrition and Eating Habits',
  },
  {
    label: 'Socialization and Friendships',
    value: 'Socialization and Friendships',
  },
  { label: 'Aggression', value: 'Agression' },
  { label: 'Discipline', value: 'Discipline' },
  { label: 'Sibling Dynamics', value: 'Sibling Dynamics' },
  { label: 'Health and safety', value: 'Health and safety' },
  { label: 'Temper tantrums', value: 'Temper tantrums' },
  { label: 'Time Management', value: 'Time Management' },
  { label: 'School Readiness', value: 'School Readiness' },
  { label: 'Educational Support', value: 'Educational Support' },
  {
    label: 'Other challenging behaviors',
    value: 'Other challenging behaviors',
  },
  { label: 'Life skill', value: 'Life skill' },
  {
    label: 'Cultural and Diversity Factors',
    value: 'Cultural and Diversity Factors',
  },
  { label: 'Free Topic', value: 'Free Topic' },
  { label: 'Emotional Intelligence', value: 'Emotional Intelligence' },
  { label: 'Sports', value: 'Sports' },
];
export const stylesOptions: StyleOption[] = [
  { label: '3D Illustration', value: '3D Illustration', id: 0 },
  { label: 'Anime', value: 'Anime', id: 1 },
  { label: 'Book Cover Illustration', value: 'Book Cover Illustration', id: 2 },
  { label: 'Cartoon', value: 'Cartoon', id: 3 },
  {
    label: 'Charming Storybook Illustration',
    value: 'Charming Storybook Illustration',
    id: 4,
  },
  { label: 'Claymation Style', value: 'Claymation Style', id: 5 },
  { label: 'Coloring Book', value: 'Coloring Book', id: 6 },
  { label: 'Comic Book', value: 'Comic Book', id: 5 },
  {
    label: 'Four-panel Comic Strip Illustration',
    value: 'Four-panel Comic Strip Illustration',
    id: 8,
  },
  {
    label: 'Handmade Paper Cut-out Collage Illustration',
    value: 'Handmade Paper Cut-out Collage Illustration',
    id: 9,
  },
  { label: 'Isometric Illustration', value: 'Isometric Illustration', id: 10 },
  { label: 'Lego', value: 'Lego', id: 11 },
  { label: 'Low Poly', value: 'Low Poly', id: 12 },
  { label: 'Minimalist Ink-style', value: 'Minimalist Ink-style', id: 13 },
  {
    label: 'Minimalistic Illustration',
    value: 'Minimalistic Illustration',
    id: 14,
  },
  { label: 'Minecraft Style', value: 'Minecraft Style', id: 15 },
  { label: 'Pastel Drawing Style', value: 'Pastel Drawing Style', id: 16 },
  { label: 'Photorealistic', value: 'Photorealistic', id: 18 },
  { label: 'Pixar Style', value: 'Pixar Style', id: 19 },
  { label: 'Pop Art Style', value: 'Pop Art Style', id: 20 },
  {
    label: "Retro 1950s Children's Book Illustration",
    value: "Retro 1950s Children's Book Illustration",
    id: 21,
  },
  { label: 'Sketch Styles', value: 'Sketch Styles', id: 22 },
  {
    label: 'Stencil-style Street Art Mural',
    value: 'Stencil-style Street Art Mural',
    id: 23,
  },
  {
    label: 'Stylized Digital Illustration',
    value: 'Stylized Digital Illustration',
    id: 24,
  },
  { label: 'Vintage-style', value: 'Vintage-style', id: 25 },
  { label: 'Watercolor', value: 'Watercolor', id: 26 },
  { label: 'Whimsical Illustration', value: 'Whimsical Illustration', id: 27 },
];
export const languagesOptions: OptionProps[] = [
  { label: 'English', value: 'English' },
  { label: 'French', value: 'French' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'German', value: 'German' },
  { label: 'Chinese', value: 'Chinese (zh-cn)' },
  { label: 'Persian', value: 'Persian (fa-ir)' },
  { label: 'Korean', value: 'Korean (ko-kr)' },
];

export const perspectiveOptions: OptionProps[] = [
  { label: 'Omniscient narrator', value: 'Omniscient narrator' },
  {
    label: 'First-person from the child',
    value: 'First-person from the child',
  },
  { label: 'First-person from a parent', value: 'First-person from a parent' },
  { label: 'Third-person limited', value: 'Third-person limited' },
  {
    label: 'Dialogue between characters',
    value: 'Dialogue between characters',
  },
  { label: 'Animal narrator', value: 'Animal narrator' },
  { label: 'Imaginary friend narrator', value: 'Imaginary friend narrator' },
];

export const styleOptions: OptionProps[] = [
  { label: 'Fantasy', value: 'Fantasy' },
  { label: 'Realistic', value: 'Realistic' },
  { label: 'Funny', value: 'Funny' },
  { label: 'Poetic', value: 'Poetic' },
  { label: 'Educational', value: 'Educational' },
  { label: 'Folk Tale', value: 'Folk Tale' },
  { label: 'Sci-Fi', value: 'Sci-Fi' },
  { label: 'Adventure', value: 'Adventure' },
  { label: 'Bedtime', value: 'Bedtime' },
  { label: 'Moral Tale', value: 'Moral Tale' },
];

export const toneOptions: OptionProps[] = [
  { label: 'Gentle', value: 'Gentle' },
  { label: 'Humorous', value: 'Humorous' },
  { label: 'Poetic', value: 'Poetic' },
  { label: 'Adventurous', value: 'Adventurous' },
  { label: 'Uplifting', value: 'Uplifting' },
  { label: 'Calming', value: 'Calming' },
  { label: 'Whimsical', value: 'Whimsical' },
  { label: 'Mysterious', value: 'Mysterious' },
  { label: 'Dramatic', value: 'Dramatic' },
  { label: 'Educational', value: 'Educational' },
];
